module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADcSURBVEhL5Y8hEgIxDEV3Zh0GheQIaDynYIaToDjFcg8EfiWaG2CrMAhMy2/7g1nYNt0qeDOZTtPkpWn+C2vtDrHntS4QbxBPhGfLdB0gXDnn7ogA7g/Ems/TgGiBuNH9BjmDWLKsDHhmkFyicgjerjjmLNeBxhaCUzCNgJozjpZt+aDxGBVpfC3b9KD5QM8A/8ayMsbkQvGQHLmgHqKRC9lDSuSCahPNIJXYU7JF9pASuZAcMkUufB1SQy4kN/kEmjr2e0HHdD3g7aM+0DNdD/zaUO43MEz/PE3zAhOxHQegEWARAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-evergreen/light/24.png
// module id = 2018
// module chunks = 2